import React from 'react';
import { useTranslation } from 'react-i18next';
import ReactCountryFlag from 'react-country-flag';
import { useLocation, useNavigate } from 'react-router-dom';

export function LanguageToggle() {
  const { i18n } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  const toggleLanguage = () => {
    const currentPath = location.pathname;
    const newLang = i18n.language.startsWith('en') ? 'id' : 'en';
    
    // Change the language in i18n
    i18n.changeLanguage(newLang);
    
    // Update the URL path
    const newPath = currentPath.replace(/^\/(en|id)/, `/${newLang}`);
    navigate(newPath);
  };

  const currentLang = i18n.language.startsWith('en') ? 'EN' : 'ID';
  const currentFlag = i18n.language.startsWith('en') ? 'GB' : 'ID';

  return (
    <button
      onClick={toggleLanguage}
      className="flex items-center space-x-2 text-gray-300 hover:text-white px-3 py-2 rounded-md text-sm font-medium"
      aria-label="Toggle language"
    >
      <ReactCountryFlag 
        countryCode={currentFlag}
        svg
        style={{
          width: '1.5em',
          height: '1.5em',
        }}
        title={currentFlag}
      />
      <span>{currentLang}</span>
    </button>
  );
} 